import React from "react";

import Alert from "veneer/Alert";
import Box from "veneer/Box";

import { useAppSelector } from "cortex/ui/src/hooks";
import { getConnDeviceStatus } from "cortex/ui/src/redux-store/connection/selectors";
import { RootState } from "cortex/ui/src/redux-store/store";

interface WsDsConnStatusProps {
  mb?: number;
}

export default function WsDsConnStatus({ mb }: WsDsConnStatusProps) {
  const deviceStatusOnline = useAppSelector((state: RootState) =>
    getConnDeviceStatus(state),
  );

  if (deviceStatusOnline !== false) return null;

  return (
    <Box mb={mb}>
      <Alert dense severity="warning">
        We can't show device status (online or offline) right now. Your devices
        are not affected.
      </Alert>
    </Box>
  );
}
